import React from 'react';
import './platform-tabs.less';
import { Tabs } from './tabs';
import type { ProductContext } from '../../../content/types/content';
import type { AnalyticsMetadata } from '../../utils/analytics/types';
import { ProductCardsGroup } from '../product-card';
import analytics from '../../utils/analytics';
import { camelCase } from 'lodash';
import { translatableText } from '../../utils/translatable-text';

const CLOUD_TAB = 'Cloud';
const DATA_CENTER_TAB = 'Data Center';

const getAnalyticsTabLabel = (label: string) =>
    label === translatableText.server.text ? DATA_CENTER_TAB : CLOUD_TAB;

interface PlatformTabsProps {
    cloudProducts: ProductContext[];
    serverProducts: ProductContext[];
    details: string;
    analyticsMetadata: AnalyticsMetadata;
}

const handleTabSelect = (details: string, tab: string) => {
    const tabName = tab === 'Data Center' ? 'Server' : tab;
    analytics.trackEvent(camelCase(tabName + ' tab'), {
        event: 'clicked',
        eventComponent: 'tab',
        category: 'products cloud and server tabs',
        actionSubjectId: camelCase(details + ' products ' + tabName + ' tab'),
        action: 'click',
        label: tab
    });
};

const handleKeyDown = (details: string, tab: string, keyboardEvent: string) => {
    const tabName = tab === 'Data Center' ? 'Server' : tab;
    analytics.trackEvent(camelCase(tabName + ' tab'), {
        event: 'keyboard',
        eventComponent: 'tab',
        category: 'products cloud and server tabs',
        actionSubjectId: camelCase(details + ' products ' + tabName + ' tab'),
        action: 'selected',
        label: tab,
        keyboardEvent
    });
};

export const PlatformTabs = ({
    cloudProducts,
    serverProducts,
    details,
    analyticsMetadata
}: PlatformTabsProps) => {
    const tabs = [
        {
            label: translatableText.cloud.text,
            content: (
                <ProductCardsGroup
                    productList={cloudProducts}
                    analyticsMetadata={analyticsMetadata}
                    renderV2={true}
                />
            )
        },
        {
            label: translatableText.server.text,
            content: (
                <ProductCardsGroup
                    productList={serverProducts}
                    analyticsMetadata={analyticsMetadata}
                    renderV2={true}
                />
            )
        }
    ];

    return (
        <Tabs
            tabs={tabs}
            onSelect={(selected) => {
                handleTabSelect(details, getAnalyticsTabLabel(selected.label));
            }}
            onKeyDown={(selected, keyboardEvent) => {
                handleKeyDown(
                    details,
                    getAnalyticsTabLabel(selected.label),
                    keyboardEvent
                );
            }}
        />
    );
};
